/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var MoyaOverlayClass = MoyaContainer.get('core.overlay').OverlayClass;
    var OverlayStyle;
    (function (OverlayStyle) {
        OverlayStyle["DARK"] = "dark";
        OverlayStyle["LIGHT"] = "light";
    })(OverlayStyle || (OverlayStyle = {}));
    MoyaComponents.register('gcert.filter', function (el) {
        var item = new AllFilter(el);
        item.run();
    });
    var AllFilter = /** @class */ (function () {
        function AllFilter(el) {
            this.el = el;
            this.occasionBaseUrl = el.dataset.occasionBaseUrl;
            this.currentOccasion = this.getCurrentParam('o');
            this.currentPrice = this.getCurrentParam('p');
        }
        AllFilter.prototype.run = function () {
            this.bind();
        };
        AllFilter.prototype.bind = function () {
            var _this = this;
            var overlay = new MoyaOverlayClass(document.querySelector('.gcert__templates'), { style: OverlayStyle.LIGHT });
            this.el.querySelectorAll('.occasions li a').forEach(function (a) {
                util.delegate(a, 'click', 'a', function (e) {
                    overlay.show("spinner" /* SPINNER */);
                    e.preventDefault();
                    var target = e.delegateTarget;
                    _this.currentOccasion = _this.getParamFromHref(target, 'o');
                    _this.updateView();
                    overlay.hide();
                });
            });
            this.el.querySelectorAll('.prices li a').forEach(function (a) {
                util.delegate(a, 'click', 'a', function (e) {
                    overlay.show("spinner" /* SPINNER */);
                    e.preventDefault();
                    var target = e.delegateTarget;
                    _this.currentPrice = _this.getParamFromHref(target, 'p');
                    _this.updateView();
                    overlay.hide();
                });
            });
        };
        AllFilter.prototype.getParamFromHref = function (target, param) {
            var urlSearchParams = new URLSearchParams(target.getAttribute('href'));
            return urlSearchParams.get(param);
        };
        AllFilter.prototype.getCurrentParam = function (param) {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            return urlParams.has(param) ? urlParams.get(param) : '';
        };
        AllFilter.prototype.updateView = function () {
            var _this = this;
            var moyaFetch = MoyaContainer.get('core.fetch');
            moyaFetch.fetchHtml(this.getUpdateUrl()).then(function (res) {
                document.querySelector('.gcert__templates').replaceWith(res.querySelector('.gcert__templates'));
                document.querySelectorAll('.gcert__template').forEach(function (item) {
                    item.classList.add('visible');
                });
                if (_this.currentPrice !== '') {
                    var token_1 = 'p-' + _this.currentPrice;
                    document.querySelectorAll('.gcert__template').forEach(function (item) {
                        if (!item.classList.contains(token_1)) {
                            item.classList.remove('visible');
                        }
                    });
                }
            });
        };
        AllFilter.prototype.getUpdateUrl = function () {
            var urlParams = new URLSearchParams();
            if (this.currentPrice !== '') {
                urlParams.set('p', this.currentPrice);
            }
            if (this.currentOccasion !== '') {
                urlParams.set('o', this.currentOccasion);
            }
            return this.occasionBaseUrl + '?' + urlParams.toString();
        };
        return AllFilter;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
